/**
 * Primitive Shadow Tokens
 *
 * The four elevation levels as raw geometry. Each platform renders these
 * itself — React Native as shadow* / elevation props in
 * semantic/shadows.native.ts, the web as a CSS box-shadow in
 * semantic/shadows.web.ts — so the numbers live here exactly once.
 */

export interface ShadowGeometry {
  offsetY: number;
  opacity: number;
  blur: number;
  androidElevation: number;
}

export const shadowColor = "#000000";

export const shadowGeometry = {
  none: { offsetY: 0, opacity: 0, blur: 0, androidElevation: 0 },
  low: { offsetY: 1, opacity: 0.08, blur: 3, androidElevation: 2 },
  medium: { offsetY: 2, opacity: 0.12, blur: 8, androidElevation: 4 },
  high: { offsetY: 4, opacity: 0.16, blur: 16, androidElevation: 8 },
} as const satisfies Record<string, ShadowGeometry>;

export type ShadowLevel = keyof typeof shadowGeometry;
